import { FilterType } from 'components/Shared/Table'
import { DRIVER_ADDITIONAL_DATA_READ, DRIVER_CARRIER_READ, DRIVER_DATA_READ } from 'context/auth'

export const createColumns = (hasAnyPrivileges) => {
  const driverDataColumns = hasAnyPrivileges([DRIVER_DATA_READ]) ? [
    {
      id: 'firstName',
      label: 'driver.driverTable.firstName',
      path: 'firstName',
      sortable: true,
      filterType: FilterType.Text
    },
    {
      id: 'lastName',
      label: 'driver.driverTable.lastName',
      path: 'lastName',
      sortable: true,
      filterType: FilterType.Text
    },
    {
      id: 'phoneNumber',
      label: 'driver.driverTable.phoneNumber',
      path: 'phoneNumber',
      filterType: FilterType.Text
    },
    {
      id: 'personalPhoneNumber',
      label: 'driver.driverTable.personalPhoneNumber',
      path: 'personalPhoneNumber',
      filterType: FilterType.Text
    },
    {
      id: 'address',
      label: 'driver.driverTable.address',
      path: 'address',
      filterType: FilterType.Text
    },
    {
      id: 'idCardNumber',
      label: 'driver.driverTable.idCardNumber',
      path: 'idCardNumber',
      filterType: FilterType.Text
    },
    {
      id: 'idCardExpirationDate',
      label: 'driver.driverTable.idCardExpirationDate',
      path: 'idCardExpirationDate',
      filterType: FilterType.DateRange,
      filterNames: [
        'idCardExpirationDateAfterOrEqual',
        'idCardExpirationDateBeforeOrEqual']
    },
  ] : []
  const driverAdditionalDataColumns = hasAnyPrivileges([DRIVER_ADDITIONAL_DATA_READ]) ? [
    {
      id: 'adrCardNumber',
      label: 'driver.driverTable.adrCardNumber',
      path: 'adrCertificateNumber',
      filterType: FilterType.Text
    },
    {
      id: 'adrCardExpirationDate',
      label: 'driver.driverTable.adrCardExpirationDate',
      path: 'adrCertificateExpirationDate',
      filterType: FilterType.DateRange,
      filterNames: [
        'adrExpirationDateAfterOrEqual',
        'adrExpirationDateBeforeOrEqual']
    },
    {
      id: 'driverLicenseNumber',
      label: 'driver.driverTable.driverLicenseNumber',
      path: 'driverLicenseNumber',
      filterType: FilterType.Text
    },
    {
      id: 'driverLicenseCategory',
      label: 'driver.driverTable.driverLicenseCategory',
      path: 'driverLicenseCategory',
      filterType: FilterType.Text
    },
    {
      id: 'driverLicenseExpirationDate',
      label: 'driver.driverTable.driverLicenseExpirationDate',
      path: 'driverLicenseExpirationDate',
      filterType: FilterType.DateRange,
      filterNames: [
        'driverLicenseExpirationDateAfterOrEqual',
        'driverLicenseExpirationDateBeforeOrEqual']
    },
    {
      id: 'carRegistrationNumber',
      label: 'driver.driverTable.carRegistrationNumber',
      path: 'carRegistrationNumber',
      filterType: FilterType.Text
    }
  ] : []
  const driverCarrierColumns = hasAnyPrivileges([DRIVER_CARRIER_READ]) ? [{
    id: 'carrierIds',
    label: 'driver.driverTable.carrier',
    path: 'carrierId',
    filterType: FilterType.Contractor,
  }] : []

  return [
    ...driverDataColumns,
    ...driverAdditionalDataColumns,
    ...driverCarrierColumns
  ]
}
